import { IoIosArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

import Card from '../ui/Card';

import classes from './Title.module.css';

type TitleProps = {
  titleText: string;
  backButton?: boolean;
};

const Title = (props: TitleProps) => {
  const cardStyles: React.CSSProperties = {
    flex: 0.1,
  };

  return (
    <Card extraStyles={cardStyles} withMargin={'bottom'}>
      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <div style={{ flex: 1 }}>
          <Link to="/" className={classes.link}>
            <IoIosArrowBack style={{ fontSize: 'min(1.5em, 4vw)' }} />
          </Link>
        </div>
        <div style={{ flex: 13 }}>
          <h1 className={classes.text}>{props.titleText}</h1>
        </div>
        <div style={{ flex: 1 }} />
      </div>
    </Card>
  );
};

export default Title;
